// extracted by mini-css-extract-plugin
export default {"layout-main":"index_layout-main__osCGD"};